import { useState } from "react";
import { Tag } from "@design-system/Tag/Tag";
import { TagOverflow } from "@design-system/Tag/TagOverflow";
import { NumberControl, VariantGrid, VariantItem } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import { TagOverflowPlaygroundBoard } from "./TagOverflowPlaygroundBoard";

const tagLabels = [
    "Payroll",
    "Tax",
    "Q3 close",
    "Reconciliation",
    "Client ask",
    "Urgent",
];

const buildItems = (count: number) =>
    tagLabels.slice(0, count).map((label) => ({
        id: label,
        label,
        content: (
            <Tag size="sm" color="neutral">
                {label}
            </Tag>
        ),
    }));

const variantCounts = [3, 4, 6];

/** Design-system playground for a capped row of tags with a +N popover. */
export const TagOverflowPlayground = () => {
    const [count, setCount] = useState(5);
    const [max, setMax] = useState(3);
    const items = buildItems(count);

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Items</h2>
                    <NumberControl
                        label="Tags"
                        value={count}
                        min={0}
                        max={tagLabels.length}
                        onChange={setCount}
                    />
                    <NumberControl
                        label="Max"
                        value={max}
                        min={0}
                        max={tagLabels.length}
                        onChange={setMax}
                    />
                </section>
            }
        >
            <ShowcasePreview
                summary={`${count} tags · max ${max}`}
                width="wide"
                output={JSON.stringify({ count, max }, null, 2)}
                belowStage={
                    <>
                        <VariantGrid title="Counts (max 3)" columns="three">
                            {variantCounts.map((variantCount) => (
                                <VariantItem
                                    key={variantCount}
                                    label={`${variantCount} tags`}
                                >
                                    <TagOverflow
                                        items={buildItems(variantCount)}
                                    />
                                </VariantItem>
                            ))}
                        </VariantGrid>
                        <VariantGrid title="On a board card" columns="full">
                            <TagOverflowPlaygroundBoard
                                items={items}
                                max={max}
                            />
                        </VariantGrid>
                    </>
                }
            >
                <TagOverflow items={items} max={max} />
            </ShowcasePreview>
        </SandboxLayout>
    );
};
